var cibLetterboxd = ["32 32", "<path d='M11.052 22.339v-12.74h-2.323v-3.198h8.438v3.198h-2.328v12.766h5.234v-3.49h3.781v6.724h-15.125v-3.26zM0 16c0 8.839 7.161 16 16 16s16-7.161 16-16c0-8.839-7.161-16-16-16s-16 7.161-16 16z'/>"];

export { cibLetterboxd };
//# sourceMappingURL=cib-letterboxd.js.map
